export enum BrandIconColor {
  actionBlue = 'action-blue',
  midnightBlue = 'midnight-blue',
  neutral = 'neutral',
  neutral75 = 'neutral-75',
  alert = 'alert',
  confirm = 'confirm',
  berry = 'berry',
  purple = 'purple',
  orange = 'orange',
  darkMint = 'dark-mint',
  mint = 'mint',
  white = 'white',
  lime = 'lime',
  none = 'none',
  ameripriseBlue = 'ampf-blue',
  lightBlue = 'light-blue',
  stoneDark = 'stone-dark',
  stone = 'stone'
}
